export var ContactType;
(function (ContactType) {
    ContactType["AgendaContact"] = "agendaContact";
    ContactType["Contact"] = "contact";
})(ContactType || (ContactType = {}));
